var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDynamicProjectIdentifier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.818848,
    width: 24,
    height: 24,
    rx: 8,
    fill: "url(#paint0_linear_3730_2775)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3730_2775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 12,
    height: 13
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6.81885,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3730_2775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6999 13.4563L13.8624 12.6188L14.9124 11.5688L13.8624 10.5313L14.6999 9.7063L15.7499 10.7438L16.7874 9.7063L17.6124 10.5313L16.5874 11.5688L17.6124 12.6188L16.7874 13.4563L15.7499 12.4188L14.6999 13.4563ZM10.5224 12.6438C9.87899 12.6438 9.35399 12.4405 8.9474 12.0338C8.54074 11.6272 8.3374 11.1022 8.3374 10.4588C8.3374 9.81547 8.54074 9.28963 8.9474 8.8813C9.35399 8.47297 9.87899 8.2688 10.5224 8.2688C11.1657 8.2688 11.6937 8.47297 12.1062 8.8813C12.5187 9.28963 12.7249 9.81547 12.7249 10.4588C12.7249 11.1022 12.5187 11.6272 12.1062 12.0338C11.6937 12.4405 11.1657 12.6438 10.5224 12.6438ZM6.2124 17.2938V15.7813C6.2124 15.4288 6.30282 15.1117 6.48365 14.83C6.6644 14.5484 6.91565 14.3321 7.2374 14.1813C7.87907 13.898 8.4539 13.698 8.9619 13.5813C9.4699 13.4646 9.98882 13.4063 10.5187 13.4063C11.0645 13.4063 11.5916 13.4646 12.0999 13.5813C12.6082 13.698 13.1791 13.898 13.8124 14.1813C14.1342 14.331 14.3875 14.5444 14.5724 14.8217C14.7574 15.099 14.8499 15.4179 14.8499 15.7784V17.2938H6.2124ZM7.3874 16.1188H13.6624V15.8313C13.6624 15.703 13.6246 15.5806 13.549 15.4639C13.4734 15.3473 13.3725 15.2609 13.2465 15.2049C12.6988 14.9558 12.2291 14.7917 11.8374 14.7125C11.4457 14.6334 11.0062 14.5938 10.5187 14.5938C10.0478 14.5938 9.6124 14.6334 9.2124 14.7125C8.8124 14.7917 8.33919 14.9556 7.79278 15.2043C7.66419 15.2603 7.56449 15.3467 7.49365 15.4635C7.42282 15.5803 7.3874 15.7029 7.3874 15.8313V16.1188ZM10.5244 11.4688C10.8247 11.4688 11.0687 11.3736 11.2562 11.1832C11.4437 10.9928 11.5374 10.7507 11.5374 10.4568C11.5374 10.1594 11.4438 9.91617 11.2567 9.72717C11.0694 9.53826 10.8277 9.4438 10.5317 9.4438C10.2355 9.4438 9.99157 9.53847 9.7999 9.7278C9.60824 9.91713 9.5124 10.158 9.5124 10.4505C9.5124 10.7465 9.60761 10.9902 9.79803 11.1817C9.98836 11.3731 10.2305 11.4688 10.5244 11.4688Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3730_2775",
    x1: 0,
    y1: 0.818848,
    x2: 24,
    y2: 24.8188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF50CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3553"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicProjectIdentifier);
export default __webpack_public_path__ + "static/media/dynamic_project_identifier.5757971daebeda3d0fb4fde916486c7a.svg";
export { ForwardRef as ReactComponent };